module.exports = __webpack_public_path__ + "images/emoji/construction_worker.48f1dc64c21419d7868a.png";